$(document).on('click', '.nav-toggle > a', function (e) {
  $(this).blur();
  $(this).closest('ul').toggleClass('closed');

  e.preventDefault();
  return false;
});

$(function () {
  $('.menu-wrapper').scrollLeft(Number.MAX_VALUE);
  // console.log('Javascripts are working!');
});
